import { Link } from "react-router-dom";
import useStore from "../../features/store";
import EditData from "../../components/profile/editData";
import Loading from "../../components/common/loading";

const ProfileInfo = () => {
  //@ts-ignore
  const { isLoadingProfile, profile } = useStore();

  return (
    <div className="mt-10">
      <div className="breadcrumbs text-sm">
        <ul>
          <li>
            <Link to="/profile">پروفایل</Link>
          </li>
          <li className="font-[900]">ویرایش پروفایل</li>
        </ul>
      </div>

      {isLoadingProfile ? (
        <div className="my-4 flex-1 w-full flex flex-col justify-between">
          <Loading type="profile" />
        </div>
      ) : (
        profile && <EditData />
      )}
    </div>
  );
};

export default ProfileInfo;
